import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance";

export const fetchHouseSettingsThunk = createAsyncThunk(
  "houseSettings/fetch",
  async (home_id, { rejectWithValue }) => {
    try {
      const res = await api.get(`/api/house-settings/${home_id}`);
      if (!res.data?.success) return rejectWithValue(res.data?.message);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const updateHouseSettingsThunk = createAsyncThunk(
  "houseSettings/update",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await api.post(`/api/house-settings/initial`, payload);
      if (!res.data?.success) return rejectWithValue(res.data?.message);
      return true;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const slice = createSlice({
  name: "houseSettings",
  initialState: {
    data: {},
    loading: false,
    saving: false,
    error: null,
  },
  reducers: {
    clearHouseSettingsError: (s) => {
      s.error = null;
    },
  },
  extraReducers: (b) => {
    b.addCase(fetchHouseSettingsThunk.pending, (s) => {
      s.loading = true;
    });
    b.addCase(fetchHouseSettingsThunk.fulfilled, (s, a) => {
      s.loading = false;
      s.data = a.payload || {};
    });
    b.addCase(fetchHouseSettingsThunk.rejected, (s, a) => {
      s.loading = false;
      s.error = a.payload;
    });

    b.addCase(updateHouseSettingsThunk.pending, (s) => {
      s.saving = true;
    });
    b.addCase(updateHouseSettingsThunk.fulfilled, (s) => {
      s.saving = false;
    });
    b.addCase(updateHouseSettingsThunk.rejected, (s, a) => {
      s.saving = false;
      s.error = a.payload;
    });
  },
});

export const { clearHouseSettingsError } = slice.actions;
export default slice.reducer;
